import { useMemo } from 'react';
import { FlexContainer } from 'shared/Typhography/flex-box';
import { IconCartContainer, Text } from 'shared/Typhography';
import { RemoveIcon } from 'assets/CreateScreen';

import { FileState } from '../types';
import { getContentResolution } from '../hooks';

interface HasImageOrVideoProps {
  fileState?: FileState;
  removeImage?: () => void;
  mediaType?: 'image' | 'video';
  disabled?: boolean;
}

export const HasImageOrVideo = ({
  fileState,
  removeImage,
  mediaType,
  disabled,
}: HasImageOrVideoProps) => {
  const imageResolution = getContentResolution(fileState?.url, mediaType);

  const type = useMemo(
    () => mediaType ?? ((fileState?.fileType ?? 'image')?.includes('image') ? 'image' : 'video'),
    [mediaType, fileState?.fileType],
  );

  return (
    <>
      {imageResolution && (
        <FlexContainer
          flexDirection="row"
          dimensions={{ width: '100%' }}
          gap="5px"
          alignItems="flex-end"
        >
          <Text size={1.5}>Resolution:</Text>
          <Text size={2}>
            {imageResolution?.width}x{imageResolution?.height}
          </Text>
        </FlexContainer>
      )}
      <FlexContainer position="relative" dimensions={{ width: '100%', height: '100%' }}>
        {type === 'image' && (
          <img
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            src={fileState?.url}
          />
        )}
        {type === 'video' && (
          <video
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            loop={true}
            autoPlay={true}
            muted={true}
          >
            <source src={fileState?.url} type={fileState?.fileType} />
          </video>
        )}

        {!disabled && (
          <FlexContainer
            position="absolute"
            dimensions={{ width: '100%', height: '100%' }}
            justifyContent="flex-end"
            alignItems="flex-start"
            padding={{ padding: '32px' }}
            style={{ zIndex: 0 }}
          >
            <IconCartContainer onClick={removeImage}>
              <img src={RemoveIcon} />
            </IconCartContainer>
          </FlexContainer>
        )}
      </FlexContainer>
    </>
  );
};
